import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-12 mb-3" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "col-md-12" }
const _hoisted_7 = { class: "border border-primary mb-10" }
const _hoisted_8 = { class: "d-flex align-items-center justify-content-between fw-bold py-2 bg-primary" }
const _hoisted_9 = { class: "col-md-7" }
const _hoisted_10 = { class: "fs-4 text-white px-2" }
const _hoisted_11 = { class: "col-md-4 mb-2" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = { class: "input-group" }
const _hoisted_14 = { class: "input-group-text list-light-primary" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onUpdate:modelValue"]
const _hoisted_17 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_18 = { class: "col-md-2" }
const _hoisted_19 = { class: "form-group mb-2" }
const _hoisted_20 = ["onUpdate:modelValue"]
const _hoisted_21 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_22 = { class: "col-md-2" }
const _hoisted_23 = { class: "form-group mb-2" }
const _hoisted_24 = ["onUpdate:modelValue"]
const _hoisted_25 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_26 = { class: "col-md-1 mb-2" }
const _hoisted_27 = { class: "form-group" }
const _hoisted_28 = ["onUpdate:modelValue"]
const _hoisted_29 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_30 = { class: "col-md-1" }
const _hoisted_31 = { class: "form-group mb-2" }
const _hoisted_32 = ["onUpdate:modelValue"]
const _hoisted_33 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_34 = { class: "col-md-2" }
const _hoisted_35 = { class: "form-group mb-2" }
const _hoisted_36 = ["onUpdate:modelValue"]
const _hoisted_37 = { class: "col-md-12 mt-3" }
const _hoisted_38 = { class: "d-flex align-items-center" }
const _hoisted_39 = ["disabled"]
const _hoisted_40 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Form = _resolveComponent("Form")!
  const _component_ModalDetailProdCondMagInv = _resolveComponent("ModalDetailProdCondMagInv")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Form, {
          onSubmit: _ctx.EditeInventaire,
          "validation-schema": _ctx.inventaireSchema,
          "keep-values": _ctx.valuess
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _cache[3] || (_cache[3] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Fiche d'inventaire ", -1)),
                  _createVNode(_component_Multiselect, {
                    options: _ctx.inventaireOptions,
                    searchable: true,
                    "track-by": "label",
                    label: "label",
                    modelValue: _ctx.inventaire,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inventaire) = $event)),
                    placeholder: "Sélectionner une fiche",
                    onSelect: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectInventaire(_ctx.inventaire)))
                  }, null, 8, ["options", "modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("h4", _hoisted_10, _toDisplayString(_ctx.magasinss? _ctx.magasinss:"Magasin"), 1)
                    ]),
                    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "col-md-5" }, [
                      _createElementVNode("div", { class: "d-flex float-end" })
                    ], -1))
                  ]),
                  _createElementVNode("div", null, [
                    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "row gx-2 mt-10 p-2" }, [
                      _createElementVNode("div", { class: "col-md-4" }, [
                        _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                          _createTextVNode(" Produit "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ])
                      ]),
                      _createElementVNode("div", { class: "col-md-2" }, [
                        _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Stock Ven ")
                      ]),
                      _createElementVNode("div", { class: "col-md-2" }, [
                        _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Quantité Avariée ")
                      ]),
                      _createElementVNode("div", { class: "col-md-1" }, [
                        _createElementVNode("label", {
                          class: "d-block text-black fw-semibold mb-10",
                          readOnly: true
                        }, "Ecart Fiche ")
                      ]),
                      _createElementVNode("div", { class: "col-md-1" }, [
                        _createElementVNode("label", {
                          class: "d-block text-black fw-semibold mb-10",
                          readOnly: true
                        }, "Ecart Logi ")
                      ]),
                      _createElementVNode("div", { class: "col-md-2" }, [
                        _createElementVNode("label", {
                          class: "d-block text-black fw-semibold mb-10",
                          readOnly: true
                        }, "Observation ")
                      ]),
                      _createElementVNode("hr", { class: "mt-0" })
                    ], -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produits, (produit, produitIndex) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "row gx-2 px-2",
                        key: produitIndex
                      }, [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                              _createElementVNode("span", _hoisted_14, [
                                _createElementVNode("a", {
                                  class: "",
                                  href: "javascript:void(0);",
                                  onClick: ($event: any) => (_ctx.detail(produit))
                                }, _cache[5] || (_cache[5] = [
                                  _createElementVNode("i", { class: "icofont icofont-open-eye" }, null, -1)
                                ]), 8, _hoisted_15)
                              ]),
                              _withDirectives(_createElementVNode("input", {
                                class: _normalizeClass(["form-control", 
                                _ctx.validateRowProduit(produit.nomProd)
                                  ? 'form-control shadow-none fs-md-15 text-black is-invalid '
                                  : 'form-control shadow-none fs-md-15 text-black ']),
                                type: "text",
                                readonly: true,
                                "onUpdate:modelValue": ($event: any) => ((produit.nomProd) = $event),
                                placeholder: "Entrer la quantité"
                              }, null, 10, _hoisted_16), [
                                [_vModelText, produit.nomProd]
                              ])
                            ]),
                            (
                              _ctx.validateRowProduit(produit.nomProd))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_17, " Le produit est obligatoire. "))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": ($event: any) => ((produit.qtePhysique) = $event),
                              type: "number",
                              class: _normalizeClass(
                              _ctx.validateRowProduit(produit.qtePhysique)
                                ? 'form-control shadow-none fs-md-15 text-black is-invalid '
                                : 'form-control shadow-none fs-md-15 text-black '),
                              placeholder: "Entrer la quantité"
                            }, null, 10, _hoisted_20), [
                              [_vModelText, produit.qtePhysique]
                            ]),
                            (_ctx.validateRowProduit(produit.qtePhysique))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_21, " La quantité est obligatoire. "))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": ($event: any) => ((produit.qteAvariee) = $event),
                              type: "number",
                              class: _normalizeClass(
                              _ctx.validateRowProduit(produit.qteAvariee)
                                ? 'form-control shadow-none fs-md-15 text-black is-invalid '
                                : 'form-control shadow-none fs-md-15 text-black '),
                              placeholder: "Quantité Avariée"
                            }, null, 10, _hoisted_24), [
                              [_vModelText, produit.qteAvariee]
                            ]),
                            (_ctx.validateRowProduit(produit.qteAvariee))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_25, " La quantité est obligatoire. "))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("div", _hoisted_27, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": ($event: any) => ((produit.ecartFiche) = $event),
                              readonly: true,
                              type: "number",
                              class: _normalizeClass(
                                _ctx.validateRowProduit1(produit.ecartFiche)
                                  ? 'form-control shadow-none fs-md-15 text-black is-invalid '
                                  : 'form-control shadow-none fs-md-15 text-black '),
                              placeholder: "Entrer l'écart"
                            }, null, 10, _hoisted_28), [
                              [_vModelText, produit.ecartFiche]
                            ]),
                            (_ctx.validateRowProduit1(produit.ecartFiche))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_29, " L'écart est obligatoire. "))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": ($event: any) => ((produit.ecartLogique) = $event),
                              readonly: true,
                              type: "number",
                              class: _normalizeClass(
                            _ctx.validateRowProduit1(produit.ecartLogique)
                              ? 'form-control shadow-none fs-md-15 text-black is-invalid '
                              : 'form-control shadow-none fs-md-15 text-black '
                          ),
                              placeholder: "Entrer l'écart"
                            }, null, 10, _hoisted_32), [
                              [_vModelText, produit.ecartLogique]
                            ]),
                            (_ctx.validateRowProduit1(produit.ecartLogique))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_33, " L'écart est obligatoire. "))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("div", _hoisted_35, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": ($event: any) => ((produit.observation) = $event),
                              type: "text",
                              class: "form-control shadow-none text-black",
                              placeholder: "Observation"
                            }, null, 8, _hoisted_36), [
                              [_vModelText, produit.observation]
                            ])
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["btn btn-success me-3", { 'cursor-not-allowed': _ctx.isDisable }]),
                    type: "submit",
                    disabled: _ctx.isDisable
                  }, " Enregistrer ", 10, _hoisted_39),
                  _createElementVNode("button", {
                    class: _normalizeClass(["btn btn-primary me-3", { 'cursor-not-allowed': _ctx.isDisable }]),
                    type: "button",
                    disabled: _ctx.isDisable,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.Soumettre()))
                  }, " Enregistrer et Soumettre ", 10, _hoisted_40)
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema", "keep-values"])
      ])
    ]),
    (_ctx.element)
      ? (_openBlock(), _createBlock(_component_ModalDetailProdCondMagInv, {
          key: 0,
          onOpenmodal: _ctx.showModalEdite,
          item: _ctx.element
        }, null, 8, ["onOpenmodal", "item"]))
      : _createCommentVNode("", true)
  ], 64))
}